import { Day } from "./../itineray.model";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-itinerary-day-info-form",
  templateUrl: "./itinerary-day-info-form.component.html",
  styleUrls: ["./itinerary-day-info-form.component.css"]
})
export class ItineraryDayInfoFormComponent implements OnInit {
  @Input()
  day: Day;

  @Input()
  dayId: number;

  constructor() { }

  ngOnInit() { }
}
